var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxDropDownButton',{staticClass:"selectActions",attrs:{"items":_vm.items,"drop-down-options":{ width: 141.41, maxHeight: 179 },"scrollable":true,"text":_vm.$t('common.grid.selectActions'),"itemTemplate":"actionsTemp"},scopedSlots:_vm._u([{key:"actionsTemp",fn:function({ data }){return [_c('div',{staticClass:"dropdown-wrapper",class:{
        'hide-journey-border':
          data.text ==
          _vm.items.filter((item) => item.visible)[
            _vm.items.filter((item) => item.visible).length - 1
          ].text,
      },attrs:{"title":""},on:{"click":function($event){data.id == 'delete'
          ? _vm.deleteModal(
              _vm.journeyData.id,
              _vm.journeyData.mod_Parent_ID == 0 ? 'journey' : 'flow'
            )
          : _vm.redirectTo(data.id)}}},[_c('div',{staticClass:"dropdown-items",class:{ 'red-remove': data.id == 'delete' },attrs:{"title":""}},[_vm._v(" "+_vm._s(data.text)+" ")])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }